import { render, staticRenderFns } from "./NewCustomerModal.vue?vue&type=template&id=3ff4f9fc"
import script from "./NewCustomerModal.vue?vue&type=script&lang=js"
export * from "./NewCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./NewCustomerModal.vue?vue&type=style&index=0&id=3ff4f9fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports